export var INITIATORS = {
    WIDGET: 'widget',
};
